import React from 'react';
import { FGNode, FGLink, decodeHtml } from './linkGraphUtils';

export const buildNodeTooltip = (n: FGNode): React.ReactNode => (
  <div>
    <div className="font-medium text-gray-900 text-sm mb-1">{decodeHtml(n.title)}</div>
    <div className="text-xs text-gray-500 space-y-0.5">
      {n.category && <div>Category: {n.category}</div>}
      {n.community != null && <div>Community: {n.community}{n.sub_community != null ? ` / Sub: ${n.sub_community}` : ''}</div>}
      <div>Clicks (28d): {n.clicks.toLocaleString()}</div>
      <div>Impressions: {n.impressions.toLocaleString()}</div>
      {n.avg_position != null && <div>Avg position: {n.avg_position.toFixed(1)}</div>}
      {n.isOrphan && <div className="text-amber-600 font-medium mt-1">No internal links</div>}
    </div>
  </div>
);

export const buildLinkTooltip = (src: FGNode, tgt: FGNode, labels: string[], edgeLabelName: string): React.ReactNode => (
  <div className="text-xs max-w-xs">
    <div className="text-gray-900 font-medium">{decodeHtml(src.title)}</div>
    <div className="text-gray-400 my-0.5">&harr;</div>
    <div className="text-gray-900 font-medium mb-1">{decodeHtml(tgt.title)}</div>
    {labels.length > 0 && (
      <div className="text-gray-500">
        {edgeLabelName}: {labels.map((a, i) => <span key={i}>{i > 0 ? ', ' : ''}{decodeHtml(a)}</span>)}
      </div>
    )}
  </div>
);
